import Vue from 'vue';
import Vuex from 'vuex';


Vue.use(Vuex);


export default new Vuex.Store({
  state: {
    input: {
      shioriTitle: '私のハワイ旅行',
      aboutObjects: [
        {title: "旅行先", 
        comment: "ハワイ オアフ島 ホノルル"},
        {title: "滞在日", 
        comment: "12月2日(火)～12月10日(水)"},
      ],
      shioriItems: [
        {color:"blue", item:"パスポート"}, 
        {color:"red", item:"ドライヤー"}, 
        {color:"yellow", item:"ワンピース"},
        {color:"green", item:"スキンケアセット"},
      ],
      dateObjects: [
        {
          date:"10月25日(金)",
          events: [
            {
              startTime:"10:10",
              icon:"fas fa-plane fa-fw",
              title: "空港出発",
              memo: "その他メモ",
              showMemo: true,
              link: "https://www.google.com/?hl=ja",
              endTime: "18:45"
            },
            {
              startTime:"20:10",
              icon:"fas fa-car fa-fw",
              title: "ディナー",
              memo: "",
              showMemo: true,
              link: "",
              endTime: ""
            },
          ],
        },
      ]
    },
    editIndexA: "",
    editIndexD: "",
    editIndexE: "",
    editModeA: false,
    editModeD: false,
    editModeE: false,
    changeHeadTitle: true,
  },
  getters: {
    shioriTitle: state => state.input.shioriTitle,
    aboutObjects: state => state.input.aboutObjects,
    editIndexA: state => state.editIndexA,
    editIndexD: state => state.editIndexD,
    editIndexE: state => state.editIndexE,
    editModeA: state => state.editModeA,
    editModeD: state => state.editModeD,
    editModeE: state => state.editModeE,
    shioriItems: state => state.input.shioriItems,
    changeHeadTitle: state => state.changeHeadTitle,
    dateObjects: state => state.input.dateObjects,
  },
  mutations: {
    shioriTitle(state, newShioriTitle) {
      state.input.shioriTitle = newShioriTitle;
    },
    aboutObjects(state, newAboutObjects) {
      state.input.aboutObjects = newAboutObjects;
    },
    editIndexA(state, newEditIndexA) {
      state.editIndexA = newEditIndexA;
    },
    editIndexD(state, newEditIndexD) {
      state.editIndexD = newEditIndexD;
    },
    editIndexE(state, newEditIndexE) {
      state.editIndexE = newEditIndexE;
    },
    editModeA(state, newEditModeA) {
      state.editModeA = newEditModeA;
    },
    editModeD(state, newEditModeD) {
      state.editModeD = newEditModeD;
    },
    editModeE(state, newEditModeE) {
      state.editModeE = newEditModeE;
    },
    shioriItems(state, newShioriItems) {
      state.input.shioriItems = newShioriItems;
    },
    changeHeadTitle(state, newHeadTitle) {
      state.changeHeadTitle = newHeadTitle;
    },
    dateObjects(state, newDateObjects) {
      state.input.dateObjects = newDateObjects;
    },
  },
})